import React from "react";

export default function Charters() {
  return (
    <section className="text-gray-800">
      <div className="m-auto max-w-8xl">Charters</div>
    </section>
  );
}
